import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchSchedule({ container_scheduled_service_id }) {
    return RequesterV1.get(
      `service_provider/services/container_op/edit_container/fetch_container_scheduled_service/${container_scheduled_service_id}`
    );
  },
  fetchAgroExporter({ container_scheduled_service_id }) {
    return RequesterV1.get(
      `service_provider/services/container_op/edit_container/fetch_agro_exporter/${container_scheduled_service_id}`
    );
  },
  fetchContainers({ container_scheduled_service_id }) {
    return RequesterV1.get(
      `service_provider/services/container_op/edit_container/fetch_containers/${container_scheduled_service_id}`
    );
  },
  update({ container_scheduled_service_id, container_id, container_code, agro_exporter_process_id }) {
    return RequesterV1.patch(
      `service_provider/services/container_op/edit_container/update/${container_scheduled_service_id}`,
      {
        container: {
          id: container_id,
          container_code,
          agro_exporter_process_id,
        },
      }
    );
  },
};
